import {BaseCaller} from './api';

export default class ReportApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    racesGeneral(data: {init: string;  end: string;   branch: number; driver: number, report: number}) {
        
        return this.caller.get(`report/races?init=${data.init}&end=${data.end}&driverId=${data.driver}&branchId=${data.branch}&reportId=${data.report}`);
    }

    reportList(){
        return this.caller.get('report/adminReports');
    }

    
}



// WEBPACK FOOTER //
// ./src/api/report-api.ts